export default __webpack_public_path__ + "static/og-image-ec8c64b30551d4d359e75263845b8b47.jpg";